import { Alert, AlertTitle } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @description Renders an Alert component from the @mui/material library.
 * 
 * @author Maria Eduarda Franke
 * @param {string} severity - The severity level of the alert. Possible values are 'error', 'warning', 'info', or 'success'.
 * @param {string} title - The title of the alert.
 * @param {string} message - The message content of the alert.
 * @returns {React.Element} - The rendered Alert component.
 */
const MyAlert = ({ severity, title, message, ...props }) => {
    return (
        <Alert severity={severity} sx={{ width: '100%' }} {...props}>
            {title && (<AlertTitle>{title}</AlertTitle>)}
            {message}
        </Alert>
    )
}

MyAlert.propTypes = {
    severity: PropTypes.oneOf(['warning', 'error', 'info', 'success']).isRequired,
    title: PropTypes.string,
    message: PropTypes.string.isRequired
}

export { MyAlert as Alert }
